import { render, staticRenderFns } from "./PostureDietDetail.vue?vue&type=template&id=4bfd4764&scoped=true&"
import script from "./PostureDietDetail.vue?vue&type=script&lang=js&"
export * from "./PostureDietDetail.vue?vue&type=script&lang=js&"
import style0 from "./PostureDietDetail.vue?vue&type=style&index=0&id=4bfd4764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd4764",
  null
  
)

export default component.exports